import { VIEWALLMAP } from "app/constants/generic";
import React, { useEffect } from "react";
import { countries } from "../constants/index";
// import "../containers/new-report/partitions/style.css";
import "./style.css";

const jQuery = require("jquery");

const $ = jQuery;
window.jQuery = jQuery;
require("jvectormap");
require("../utils/world_mill");

// var val = 2009;
// const data = {"states":{"2005":{"US-AL":7.2,"US-AK":8.6,"US-AZ":6.3,"US-AR":6.9,"US-CA":7.2,"US-CO":6.2,"US-CT":6.3,"US-DE":5.6,"US-DC":9.1,"US-FL":6.3,"US-GA":7.4,"US-HI":4.4,"US-ID":5.8,"US-IL":7.9,"US-IN":6.9,"US-IA":5.1,"US-KS":5.5,"US-KY":7.5,"US-LA":9.0,"US-ME":5.7,"US-MD":5.7,"US-MA":6.4,"US-MI":8.9,"US-MN":5.5,"US-MS":9.3,"US-MO":6.7,"US-MT":5.3,"US-NE":4.9,"US-NV":5.8,"US-NH":4.8,"US-NJ":6.3,"US-NM":7.3,"US-NY":7.0,"US-NC":7.1,"US-ND":3.8,"US-OH":7.4,"US-OK":6.6,"US-OR":7.5,"US-PA":6.7,"US-RI":6.1,"US-SC":8.0,"US-SD":4.9,"US-TN":7.1,"US-TX":7.6,"US-UT":5.3,"US-VT":5.3,"US-VA":5.2,"US-WA":7.2,"US-WV":7.2,"US-WI":6.2,"US-WY":5.3},"2006":{"US-AL":6.9,"US-AK":9.4,"US-AZ":4.9,"US-AR":7.0,"US-CA":6.6,"US-CO":5.5,"US-CT":6.2,"US-DE":5.9,"US-DC":8.5,"US-FL":5.5,"US-GA":6.9,"US-HI":4.4,"US-ID":5.3,"US-IL":7.2,"US-IN":6.9,"US-IA":4.9,"US-KS":5.3,"US-KY":6.9,"US-LA":7.8,"US-ME":5.3,"US-MD":5.3,"US-MA":5.8,"US-MI":9.5,"US-MN":5.2,"US-MS":8.9,"US-MO":6.3,"US-MT":4.8,"US-NE":4.8,"US-NV":5.2,"US-NH":4.5,"US-NJ":6.3,"US-NM":6.4,"US-NY":6.5,"US-NC":6.6,"US-ND":3.3,"US-OH":7.1,"US-OK":6.0,"US-OR":6.3,"US-PA":6.2,"US-RI":5.9,"US-SC":7.4,"US-SD":4.3,"US-TN":7.4,"US-TX":7.0,"US-UT":4.4,"US-VT":4.8,"US-VA":4.7,"US-WA":6.4,"US-WV":6.8,"US-WI":5.5,"US-WY":3.5},"2007":{"US-AL":6.7,"US-AK":8.8,"US-AZ":5.8,"US-AR":7.2,"US-CA":6.6,"US-CO":5.5,"US-CT":6.0,"US-DE":5.6,"US-DC":8.1,"US-FL":6.2,"US-GA":7.0,"US-HI":4.5,"US-ID":5.1,"US-IL":7.2,"US-IN":6.6,"US-IA":4.8,"US-KS":5.1,"US-KY":6.6,"US-LA":6.4,"US-ME":6.0,"US-MD":5.5,"US-MA":6.1,"US-MI":9.6,"US-MN":5.4,"US-MS":9.3,"US-MO":6.3,"US-MT":5.2,"US-NE":4.6,"US-NV":5.6,"US-NH":5.1,"US-NJ":5.9,"US-NM":5.6,"US-NY":6.2,"US-NC":6.9,"US-ND":3.5,"US-OH":7.2,"US-OK":5.4,"US-OR":6.5,"US-PA":5.9,"US-RI":6.3,"US-SC":6.9,"US-SD":4.1,"US-TN":6.9,"US-TX":5.9,"US-UT":3.8,"US-VT":5.1,"US-VA":4.8,"US-WA":6.0,"US-WV":6.2,"US-WI":5.7,"US-WY":3.7},"2008":{"US-AL":7.0,"US-AK":7.7,"US-AZ":6.1,"US-AR":6.6,"US-CA":7.5,"US-CO":4.9,"US-CT":6.4,"US-DE":6.6,"US-DC":7.8,"US-FL":7.5,"US-GA":7.0,"US-HI":4.1,"US-ID":5.5,"US-IL":6.9,"US-IN":6.9,"US-IA":3.9,"US-KS":4.4,"US-KY":6.9,"US-LA":6.0,"US-ME":5.9,"US-MD":5.4,"US-MA":6.0,"US-MI":9.5,"US-MN":4.9,"US-MS":7.8,"US-MO":6.1,"US-MT":4.7,"US-NE":4.0,"US-NV":7.3,"US-NH":4.5,"US-NJ":5.9,"US-NM":6.0,"US-NY":6.3,"US-NC":6.8,"US-ND":3.2,"US-OH":7.0,"US-OK":4.6,"US-OR":6.7,"US-PA":5.7,"US-RI":7.5,"US-SC":7.7,"US-SD":3.7,"US-TN":6.9,"US-TX":5.2,"US-UT":4.0,"US-VT":4.9,"US-VA":4.9,"US-WA":5.6,"US-WV":5.7,"US-WI":5.1,"US-WY":3.3},"2009":{"US-AL":11.1,"US-AK":9.5,"US-AZ":10.6,"US-AR":9.1,"US-CA":11.3,"US-CO":8.5,"US-CT":9.2,"US-DE":8.6,"US-DC":11.1,"US-FL":12.1,"US-GA":11.2,"US-HI":7.1,"US-ID":9.6,"US-IL":10.6,"US-IN":11.0,"US-IA":6.0,"US-KS":7.2,"US-KY":10.1,"US-LA":8.4,"US-ME":7.2,"US-MD":8.0,"US-MA":9.1,"US-MI":14.7,"US-MN":8.2,"US-MS":10.7,"US-MO":9.0,"US-MT":7.9,"US-NE":6.0,"US-NV":12.1,"US-NH":7.8,"US-NJ":9.8,"US-NM":9.0,"US-NY":9.0,"US-NC":11.0,"US-ND":3.8,"US-OH":11.1,"US-OK":6.8,"US-OR":11.8,"US-PA":9.1,"US-RI":9.6,"US-SC":11.7,"US-SD":5.2,"US-TN":11.1,"US-TX":8.2,"US-UT":7.8,"US-VT":7.6,"US-VA":7.4,"US-WA":9.5,"US-WV":7.7,"US-WI":8.2,"US-WY":5.9}},"metro":{"codes":["3100000US12060","3100000US12420","3100000US12580","3100000US13820","3100000US14460","3100000US15380","3100000US16740","3100000US16980","3100000US17140","3100000US17460","3100000US18140","3100000US19100","3100000US19740","3100000US19820","3100000US25540","3100000US26420","3100000US26900","3100000US27260","3100000US28140","3100000US29820","3100000US31100","3100000US31140","3100000US32820","3100000US33100","3100000US33340","3100000US33460","3100000US34980","3100000US35380","3100000US35620","3100000US36420","3100000US36740","3100000US37980","3100000US38060","3100000US38300","3100000US38900","3100000US39300","3100000US39580","3100000US40060","3100000US40140","3100000US40380","3100000US40900","3100000US41180","3100000US41620","3100000US41700","3100000US41740","3100000US41860","3100000US41940","3100000US42660","3100000US45300","3100000US46060","3100000US47260","3100000US47900"],"coords":[[33.9783241,-84.4783064],[30.51220349999999,-97.67312530000001],[39.4014955,-76.6019125],[33.37857109999999,-86.80439],[43.1938516,-71.5723953],[43.0026291,-78.8223134],[33.836081,-81.1637245],[41.7435073,-88.0118473],[39.1031182,-84.5120196],[41.6661573,-81.339552],[39.9611755,-82.99879419999999],[32.735687,-97.10806559999999],[39.9205411,-105.0866504],[42.8105356,-83.0790865],[41.754166,-72.624443],[29.7355047,-94.97742740000001],[39.978371,-86.1180435],[30.3321838,-81.65565099999999],[39.0653602,-94.5624426],[36.0849963,-115.1511364],[34.0596149,-118.1122679],[38.3964426,-85.4375574],[35.0387247,-89.8505012],[26.2378597,-80.1247667],[43.0166806,-88.0070315],[44.9389111,-93.1177555],[35.8905359,-86.7618425],[29.984544,-90.2042505],[40.7143528,-74.00597309999999],[35.4675602,-97.5164276],[28.2919557,-81.40757099999999],[39.8373479,-75.1545381],[33.48374,-111.9164779],[40.44062479999999,-79.9958864],[45.5809394,-122.7077056],[41.679407,-71.104972],[35.772096,-78.6386145],[37.5407246,-77.4360481],[34.0633443,-117.6508876],[43.16103,-77.6109219],[38.672006,-121.367741],[38.6105426,-90.3371889],[40.7607793,-111.8910474],[29.4241219,-98.49362819999999],[33.0763386,-117.2205771],[37.6788056,-122.2880726],[37.3666767,-121.958687],[47.610377,-122.2006786],[27.9249117,-82.5943072],[32.2217429,-110.926479],[36.9211118,-76.32017549999999],[18.5204,-77.41000939999999]],"names":["Atlanta-Sandy Springs-Marietta, GA","Austin-Round Rock, TX","Baltimore-Towson, MD","Birmingham-Hoover, AL","Boston-Cambridge-Quincy, MA-NH","Buffalo-Niagara Falls, NY","Charlotte-Gastonia-Concord, NC-SC","Chicago-Naperville-Joliet, IL-IN-WI","Cincinnati-Middletown, OH-KY-IN","Cleveland-Elyria-Mentor, OH","Columbus, OH","Dallas-Fort Worth-Arlington, TX","Denver-Aurora-Broomfield, CO","Detroit-Warren-Livonia, MI","Hartford-West Hartford-East Hartford, CT","Houston-Sugar Land-Baytown, TX","Indianapolis-Carmel, IN","Jacksonville, FL","Kansas City, MO-KS","Las Vegas-Paradise, NV","Los Angeles-Long Beach-Santa Ana, CA","Louisville-Jefferson County, KY-IN","Memphis, TN-MS-AR","Miami-Fort Lauderdale-Pompano Beach, FL","Milwaukee-Waukesha-West Allis, WI","Minneapolis-St. Paul-Bloomington, MN-WI","Nashville-Davidson--Murfreesboro--Franklin, TN","New Orleans-Metairie-Kenner, LA","New York-Northern New Jersey-Long Island, NY-NJ-PA","Oklahoma City, OK","Orlando-Kissimmee, FL","Philadelphia-Camden-Wilmington, PA-NJ-DE-MD","Phoenix-Mesa-Scottsdale, AZ","Pittsburgh, PA","Portland-Vancouver-Beaverton, OR-WA","Providence-New Bedford-Fall River, RI-MA","Raleigh-Cary, NC","Richmond, VA","Riverside-San Bernardino-Ontario, CA","Rochester, NY","Sacramento--Arden-Arcade--Roseville, CA","St. Louis, MO-IL","Salt Lake City, UT","San Antonio, TX","San Diego-Carlsbad-San Marcos, CA","San Francisco-Oakland-Fremont, CA","San Jose-Sunnyvale-Santa Clara, CA","Seattle-Tacoma-Bellevue, WA","Tampa-St. Petersburg-Clearwater, FL","Tucson, AZ","Virginia Beach-Norfolk-Newport News, VA-NC","Washington-Arlington-Alexandria, DC-VA-MD-WV"],"population":{"2005":[4828838,1406364,2583923,1069498,4270631,1111554,1491330,9272117,2026216,2082379,1665428,5727391,2327901,4428941,1140319,5193448,1608730,1223882,1909666,1691213,12703423,1183916,1236181,5334685,1480517,3076239,1384347,1292774,18351099,1124533,1903273,5644383,3805123,2314937,2063277,1565972,924415,1132036,3827946,996309,2004476,2725336,1017572,1844018,2824259,4071751,1726057,3133715,2596556,902720,1585416,5119490],"2006":[5134871,1506425,2658405,1089883,4455217,1137520,1582627,9506859,2105010,2114155,1725570,6006094,2408622,4468966,1188841,5542048,1669370,1276856,1966790,1777539,12950129,1220636,1268328,5463857,1509981,3175041,1455296,1024678,18818536,1173632,1984855,5826742,4039182,2370776,2137599,1612989,995662,1196411,4026135,1035435,2067117,2793988,1067190,1948437,2941454,4180027,1784826,3263497,2697731,946362,1647400,5288670],"2007":[5271550,1593400,2668056,1106765,4482857,1128183,1650667,9522879,2134864,2096471,1754337,6144489,2466591,4467592,1189113,5629127,1697964,1296676,1980977,1836333,12875587,1228764,1283579,5413212,1544398,3208212,1521751,1030363,18815988,1193698,2032496,5827962,4179427,2355712,2174631,1600856,1049674,1211608,4081371,1030495,2091120,2802282,1095693,1997969,2974859,4203898,1803549,3309347,2723949,967089,1658215,5306125],"2008":[5368070,1650887,2667117,1117348,4522858,1124309,1701600,9568532,2155435,2088291,1773120,6303407,2502881,4425110,1190512,5722952,1715128,1315218,2001074,1865746,12872808,1244363,1288506,5414772,1549308,3229878,1552922,1134029,19006798,1202714,2054574,5838471,4281899,2351192,2209114,1596611,1086404,1230502,4115871,1034090,2109832,2813373,1112866,2032024,3001072,4274531,1819087,3344813,2733761,1012018,1657534,5356474],"2009":[5476664,1705075,2690886,1131070,4588680,1123804,1745524,9580609,2170828,2091286,1801848,6447228,2554474,4403437,1195998,5865086,1744680,1327812,2066732,1902834,12874797,1259031,1304905,5547051,1559667,3269814,1581908,1189981,19069796,1227278,2082421,5968252,4364094,2354957,2241913,1600642,1125827,1235458,4143113,1035566,2127355,2825769,1130293,2073092,3053793,4317853,1839883,3407848,2747272,1020200,1675792,5476241]},"unemployment":{"2005":[7.0,6.7,6.0,6.2,5.9,8.1,7.7,8.0,6.6,8.1,6.8,7.1,6.2,9.8,6.8,8.0,6.8,6.0,6.3,6.2,6.9,7.3,8.5,7.1,7.5,5.5,5.7,10.2,6.8,6.4,6.2,6.9,5.5,6.6,7.6,6.6,5.1,5.6,7.3,6.0,6.7,6.9,5.3,6.5,5.5,7.1,6.8,6.6,5.8,6.8,6.3,5.0],"2006":[7.1,6.0,5.3,6.4,5.4,6.1,6.5,7.5,6.4,7.9,6.4,6.7,5.7,10.5,6.3,7.3,6.5,5.8,5.7,5.3,6.1,6.8,9.2,5.6,6.1,5.3,5.9,7.9,6.5,5.6,5.4,6.8,4.2,5.9,6.1,6.1,4.9,5.8,7.4,6.4,6.7,6.6,4.4,6.7,5.0,6.0,6.1,5.5,5.5,6.3,4.7,4.6],"2007":[7.2,5.3,5.7,6.7,5.7,6.6,7.1,7.2,5.8,8.0,5.9,5.6,5.4,10.7,5.9,5.9,5.7,6.6,5.9,5.5,6.0,6.5,9.0,5.7,6.3,5.6,5.7,6.2,6.0,5.3,5.8,6.6,5.2,5.5,6.2,6.5,4.5,5.7,7.8,6.3,6.9,6.7,3.9,5.8,6.1,5.5,5.4,5.0,6.5,6.1,5.4,4.7],"2008":[7.2,5.4,5.5,6.4,5.6,6.5,6.6,7.1,5.8,7.8,5.5,5.4,4.8,10.4,5.8,5.2,6.3,6.8,5.6,7.3,6.7,6.7,8.5,7.2,5.5,5.1,5.2,6.8,6.1,4.5,7.4,6.5,5.3,5.2,6.7,7.3,5.4,6.0,10.0,5.9,8.0,6.3,3.7,5.5,6.9,6.2,6.0,4.7,7.4,6.9,5.3,4.9],"2009":[11.6,8.1,7.9,9.9,8.6,9.4,11.1,11.3,9.7,12.0,8.6,8.8,8.7,16.3,8.4,7.6,9.9,10.3,8.2,12.1,10.5,10.1,11.8,11.7,9.2,8.4,9.4,9.1,9.3,6.4,12.6,9.9,10.3,8.3,11.6,10.3,8.5,8.7,14.4,8.3,11.9,9.5,7.8,7.8,9.6,9.8,10.5,8.6,11.7,10.3,7.9,7.3]}}}

// const data = {
//   globalDistribution: {
//     coords: [
//       [18.5204, 73.8567],
//       [38.4161, 63.6167],
//       [40.7128, 74.006],
//       [53.4808, 2.2426],
//       [34.9285, 138.6007],
//     ],
//     status: [1, 0, 0, 0, 0],
//     sbc_no: [1, 2, 3, 4, 5],
//     risk_level: ["safe", "high", "high", "high", "high"],
//     tgsbc: [6, 7, 4, 8, 9],
//     rwsbc: [67, 90, 78, 88, 90],
//   },
// };

const clearBlank = () => {
  $(".jvmap-smart").children()[1] && $(".jvmap-smart").children()[0].remove();
};

const getFormatted = (count) =>
  count > 999 ? `${(count / 1000).toFixed(1)}k` : count;

// const attackOrigins = {
//   coords: [
//     [38.9072, 77.0369],
//     [61.524, 105.3188],
//     [38.9637, 35.2433],
//     [30.3753, 69.3451],
//     [35.8617, 104.1954],
//   ],
// };

const drawBlankMap = (showZoomButtons, id) => {
  // const { coords, level, country } = attackOrigination;

  $(`#${id}`).vectorMap({
    map: "world_mill",
    zoomOnScroll: false,
    zoomButtons: showZoomButtons,
    regionStyle: {
      initial: {
        fill: "#808080",
        "fill-opacity": 1,
        stroke: "#808080",
        "stroke-width": 0.2,
        "stroke-opacity": 1,
      },
      selected: {
        fill: "yellow",
      },
    },
  });
  $(".jvectormap-container").removeAttr("style");
  $(".jvectormap-container").css("background-color", "#fff");
};

const drawMap = (showZoomButtons, id, attackOrigination, attacks) => {
  let i;
  let j = 0;
  const level = [];
  const country = [];
  const occurrences = [];
  const coords = [];

  for (i = 0; i < attackOrigination.level.length; i++) {
    if (attacks === VIEWALLMAP) {
      country[j] = attackOrigination.country[i];
      level[j] = attackOrigination.level[i];
      occurrences[j] = attackOrigination.occurrences[i];
      coords[j] = attackOrigination.coords[i];
      j++;
    } else if (attackOrigination.level[i] === attacks) {
      country[j] = attackOrigination.country[i];
      level[j] = attackOrigination.level[i];
      occurrences[j] = attackOrigination.occurrences[i];
      coords[j] = attackOrigination.coords[i];
      j++;
    }
  }

  //  const {coords, level, country, occurrences}  =  attackOrigination;

  const latLngAsStrings = [];
  $(`#${id}`).vectorMap({
    map: "world_mill",
    markers: coords.map((cord, index) => {
      const cordString = `${cord[0]}${cord[1]}`;
      latLngAsStrings.push(cordString);
      const filterCords = latLngAsStrings.filter((str) => str === cordString);
      return {
        latLng: filterCords.length > 1 ? [cord[0], cord[1] + 20] : cord,
        style: {
          fill: level[index] === 1 ? "#FFA022" : "#F05757",
        },
      };
    }),
    zoomOnScroll: false,
    zoomButtons: showZoomButtons,
    series: {
      markers: [
        //   {
        //   attribute: 'fill',
        //   scale:  level === 1 ? ['#f05757'] : ["#292CA1"],
        //   values: id === "blank" ? null : level,
        // },
        {
          attribute: "r",
          scale: [20],
          values: id === "blank" ? null : null,
        },
      ],
    },
    regionStyle: {
      initial: {
        fill: "#808080",
        "fill-opacity": 1,
        stroke: "#808080",
        "stroke-width": 0.2,
        "stroke-opacity": 1,
      },
      selected: {
        fill: "yellow",
      },
    },
    labels:
      id === "blank"
        ? []
        : {
            markers:
              id === "global_distribution"
                ? {
                    render(index) {
                      if (country && country.length) {
                        return (
                          countries[country[index]] &&
                          countries[country[index]].name
                        );
                      }
                      return "10";
                    },
                  }
                : {
                    render(index) {
                      return getFormatted(occurrences[index]);
                    },
                    offsets(index) {
                      const offset =
                        occurrences[index] > 999
                          ? [-32, 0]
                          : occurrences[index]
                          ? [-30, 0]
                          : [-28, 0];
                      return offset;
                    },
                  },
          },
    markerStyle:
      id === "blank"
        ? null
        : {
            initial: {
              "stroke-width": 12,
              "stroke-opacity": 0.2,
              r: 18,
            },
            hover: {
              "stroke-width": 9,
              "stroke-opacity": 0.5,
              r: 22,
            },
          },
    markerLabelStyle:
      id === "blank"
        ? null
        : {
            initial: {
              "font-family": "Lato",
              "font-size": "12",
              "font-weight": "bold",
              cursor: "default",
              fill: "white",
            },
            hover: {
              "font-family": "Lato",
              "font-size": "14",
              "font-weight": "bold",
              cursor: "default",
              fill: "white",
            },
          },
    onMarkerTipShow:
      id === "blank"
        ? []
        : function (event, label, index) {
            label.html(
              `<b>${countries[country[index]]}` &&
                `${countries[country[index]].name}</b></br>`
            );
          },
    onRegionTipShow:
      id === "blank"
        ? []
        : function (event, label) {
            label.html(`<b>${label.html()}</b></br>`);
          },
  });
  $(".jvectormap-container").removeAttr("style");
  $(".jvectormap-container").css("background-color", "#fff");
  clearBlank();
};

const Demo = function (props) {
  const {
    showZoomButtons,
    id,
    attackOrigination,
    attackOriginationSectionWidth,
    attacks,
  } = props;

  useEffect(() => {
    id === "blank"
      ? drawBlankMap(showZoomButtons, id, attackOrigination, attacks)
      : drawMap(showZoomButtons, id, attackOrigination, attacks);
  }, [id, attackOriginationSectionWidth, attacks]);

  if (id === "blank") {
    return (
      <div className="attackSectionWidth">
        <div
          style={{ height: 412, width: "full" }}
          id={id}
          className="jvmap-smart"
        />
      </div>
    );
  }
  return (
    <div className="attackSectionWidth">
      <div
        style={{ height: 412, width: "full" }}
        id={id}
        className="jvmap-smart"
      />
    </div>
  );
};

export default Demo;
